import { useMemo } from 'react';

import { TokenIdAny, TokenIdAnyLowercase } from 'chains/chains.types';
import { COSMOS_ASSETS } from 'chains/cosmos/cosmos.assets';
import { EVM_ASSETS } from 'chains/evm/evm.assets';

export const useAsset = (tokenId: TokenIdAny | TokenIdAnyLowercase) => {
  const asset = useMemo(() => {
    return [...COSMOS_ASSETS, ...EVM_ASSETS].find(
      asset => asset.coinDenom?.toUpperCase() === tokenId?.toUpperCase(),
    )!;
  }, [tokenId]);

  return asset;
};
